import {
  faDownload,
  faPencil,
  faShare,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AgGridReact } from 'ag-grid-react'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setCurrentSlide } from 'store/CustomReports/actions'
import { extractReport } from 'store/CustomReports/actions'
import { setDownloadingFromMainPage } from 'store/CustomReports/actions'
import { editReport } from 'store/CustomReports/actions'
import { deleteReport } from 'store/CustomReports/actions'
import { fetchSavedReports } from 'store/CustomReports/actions'
import ShareModal from './ShareModal'
import { SET_ADMINS } from 'store/CustomReports/types'
import { setAdmins } from 'store/CustomReports/actions'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { FinalSlide } from './FinalSlide'
import CancelModalButton from 'components/Custom/CancelModalButton'
import { resetEverything } from 'store/CustomReports/actions'
import { setReportType } from 'store/CustomReports/actions'
import { setCourseReportType } from 'store/CustomReports/actions'
import { setCourseGroupReportType } from 'store/CustomReports/actions'

function MyReports() {
  const dispatch = useDispatch()
  const [downloadingRow, setDownloadingRow] = useState(null)
  const [modalState, setModalState] = useState({ show: false, reportId: null })

  const { user } = useSelector((store) => store.auth)

  const {
    savedReportsRows: rows,
    savedReports,
    downloadingFromMainPage,
    report,
  } = useSelector((store) => store.customReports)

  useEffect(() => {
    dispatch(fetchSavedReports())
  }, [dispatch])

  useEffect(() => {
    if (!modalState.show) {
      dispatch(setAdmins([]))
    }
  }, [dispatch, modalState])

  const [showModal, setShowModal] = useState(false)

  const columns = [
    {
      headerName: 'Report Name',
      field: 'name',
      resizable: true,
      width: 400,
      onCellClicked: (params) => {
        dispatch(editReport(params.data.id))
        setShowModal(true)
      },
    },
    {
      headerName: 'Description',
      field: 'description',
      flex: 1,
      resizable: true,
      onCellClicked: (params) => {
        dispatch(editReport(params.data.id))
        setShowModal(true)
      },
    },
    {
      headerName: '',
      field: 'download',
      cellRenderer: (params) => (
        <>
          {downloadingRow === params.data.id && downloadingFromMainPage ? (
            <span className='spinner-border spinner-border-sm'></span>
          ) : (
            <FontAwesomeIcon
              role='button'
              size='lg'
              icon={faDownload}
              title='Download Report'
              className='text-success'
              onClick={() => {
                setDownloadingRow(params.data.id)
                dispatch(setDownloadingFromMainPage(true))
                const report = savedReports?.find(
                  (report) => report.id === params.data.id
                )

                dispatch(editReport(params.data.id))
                dispatch(
                  extractReport(
                    report.name,
                    report.description,
                    false,
                    true,
                    false
                  )
                )
              }}
            />
          )}
        </>
      ),
      width: 50,
    },
    {
      headerName: '',
      field: 'share',
      cellRenderer: (params) => {
        if (params.data.user_id !== user.id && !params.data.edit_mode)
          return null

        return (
          <>
            <FontAwesomeIcon
              icon={faShare}
              title='Share Report'
              role='button'
              size='lg'
              // className='text-info'
              disabled={downloadingFromMainPage}
              onClick={() => {
                setModalState({
                  show: true,
                  reportId: params.data.id,
                  email_report: params.data.email_report,
                  email_frequency: params.data.email_frequency,
                })
              }}
            />
          </>
        )
      },
      width: 50,
    },
    {
      headerName: '',
      field: 'edit',
      cellRenderer: (params) => {
        if (params.data.user_id !== user.id && !params.data.edit_mode)
          return null

        return (
          <FontAwesomeIcon
            icon={faPencil}
            title='Edit Report'
            role='button'
            size='lg'
            className='text-info'
            disabled={downloadingFromMainPage}
            onClick={() => {
              dispatch(setCurrentSlide(1))
              dispatch(editReport(params.data.id))
            }}
          />
        )
      },
      width: 50,
    },
    {
      headerName: '',
      field: 'delete',
      cellRenderer: (params) => (
        <FontAwesomeIcon
          disabled={downloadingFromMainPage}
          icon={faTrash}
          title='Delete'
          role='button'
          onClick={() => dispatch(deleteReport(params.data.id))}
          className='text-danger'
          size='lg'
        />
      ),
      width: 50,
    },
  ]

  const closeModal = () => {
    setShowModal(false)
    dispatch(setReportType(null))
    dispatch(setCourseReportType(null))
    dispatch(setCourseGroupReportType(null))
  }

  return (
    <div
      className='ag-theme-alpine mt-4'
      style={{ height: 650, width: '100%' }}
    >
      <AgGridReact columnDefs={columns} rowData={rows} />
      {modalState.show && (
        <ShareModal modalState={modalState} setModalState={setModalState} />
      )}
      {showModal && (
        <Modal
          isOpen={showModal}
          toggle={closeModal}
          centered
          scrollable
          style={{ width: '90%', minWidth: '90%' }}
        >
          <ModalHeader className='border-bottom' toggle={closeModal}>
            {`${report?.name} (Preview)` ?? 'Preview Report'}
          </ModalHeader>
          <ModalBody className='scrollbar'>
            <FinalSlide viewOnly={true} />
          </ModalBody>
          <ModalFooter>
            <CancelModalButton text='Cancel' customFn={closeModal} />
            <button
              disabled={downloadingFromMainPage}
              className='btn btn-info ml-2'
              onClick={() => {
                dispatch(setDownloadingFromMainPage(true))

                dispatch(
                  extractReport(
                    report.name,
                    report.description,
                    false,
                    true,
                    false
                  )
                )
              }}
            >
              <FontAwesomeIcon icon={faDownload} className='mr-2' />
              {downloadingFromMainPage ? (
                <span className='spinner-border spinner-border-sm'></span>
              ) : (
                'Download'
              )}
            </button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  )
}

export default MyReports
